import React, { Component } from 'react';

import Uploads from './Uploads.js';
import Questions from './Questions.js';

import { getTranslation } from '../../Utilities/GetTranslation.js'

class Motivation extends Component {

    async isValidated() {
        // Validate the "sub" tabs
        var valid = true;
        valid = valid && (typeof this.refs.uploads.isValidated === "undefined" || await this.refs.uploads.isValidated());
        valid = valid && (typeof this.refs.questions.isValidated === "undefined" || await this.refs.questions.isValidated());

        return valid;
    }

    render() {      
        return (
            <div>
                <p><em>{getTranslation("sns.webparts.motivation.sub")}</em></p>

                <Uploads ref="uploads" job={this.props.job} onGoNext={() => this.props.onGoNext()} />                
                <Questions ref="questions" job={this.props.job} showTitle={true} />
            </div>
        );
    }
}

export default Motivation;


// WEBPACK FOOTER //
// ./src/Components/Tabs/Motivation.js